import { Badge } from "@/components/ui/badge";

const MAP = {
  normal: { label: "Normal", cls: "bg-success/12 text-success border-success/25" },
  alto: { label: "Alto", cls: "bg-destructive/12 text-destructive border-destructive/25" },
  baixo: { label: "Baixo", cls: "bg-warning/15 text-warning border-warning/30" },
  indeterminado: { label: "—", cls: "bg-muted text-muted-foreground border-border" },
};

export function StatusBadge({ status }) {
  const cfg = MAP[status] || MAP.indeterminado;
  return (
    <Badge variant="outline" className={`font-medium ${cfg.cls}`} data-testid={`status-${status}`}>
      {cfg.label}
    </Badge>
  );
}

const SEV = {
  normal: "bg-success/12 text-success border-success/25",
  positivo: "bg-success/12 text-success border-success/25",
  atencao: "bg-warning/15 text-warning border-warning/30",
  alerta: "bg-destructive/12 text-destructive border-destructive/25",
};

export function SeverityBadge({ severity, children }) {
  const cls = SEV[severity] || "bg-muted text-muted-foreground border-border";
  return (
    <Badge variant="outline" className={`font-medium capitalize ${cls}`}>
      {children || severity}
    </Badge>
  );
}
